import { SALESFORCE_STATUSES } from 'appconstants';

export default value => {
  if (value === 'SUCCEEDED') {
    return SALESFORCE_STATUSES.SUCCEEDED;
  } if (value === 'PENDING') {
    return SALESFORCE_STATUSES.PENDING;
  } return SALESFORCE_STATUSES.FAILED;
};
